/**
 * 信息集模块的接口
 * */
import base from './base' // 接口域名列表
import axios from '@/utils/http' // 导入创建的axios实例
import qs from 'qs' // 序列化post请求的
import constant from '../utils/constant'

let www = base.proxy

axios.defaults.headers.common['token'] = constant.getToken()

// 开始定义接口
const infoItem = {
  infoClassListApi () {
    return axios.post(`${www}/wtapi/external/api/infoClass/list/0`, qs.stringify({
      pageSize: 1000
    }))
  },
  saveUpdateInfoClassListApi (entityID, params) {
    return axios.post(`${www}/wtapi/external/api/infoClass/saveUpdate/${entityID}?xmlName=${params}`, { header: {
      'Content-Type': 'application/json'
    }})
  },
  infoItemListApi (params) {
    return axios.post(`${www}/wtapi/external/api/infoItem/list/${params.entityId}`, qs.stringify(params), { header: {
      'Content-Type': 'application/json'
    }})
  },
  saveUpdateInfoItemListApi (entityID, params) {
    return axios.post(`${www}/wtapi/external/api/infoItem/saveUpdate/${entityID}?xmlName=${params}`, { header: {
      'Content-Type': 'application/json'
    }})
  },
  dataSourceListApi (params) {
    return axios.post(`${www}/wtapi/external/api/dataSource/pagelist/${params.entityId}`, qs.stringify(params), { header: {
      'Content-Type': 'application/json'
    }})
  },
  saveUpdateDataSourceApi (entityID, params) {
    // axios.defaults.headers.post['Content-Type'] = 'application/json'
    return axios.post(`${www}/wtapi/external/api/dataSource/saveUpdate/${entityID}?externalValue=${params}`, { header: {
      'Content-Type': 'application/json'
    }})
  }

}

export default infoItem



// WEBPACK FOOTER //
// ./src/api/infoItem.js